import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Checkbox,
  FormControlLabel,
  Autocomplete,
  LinearProgress,
  Typography,
  InputAdornment,
  Switch,
  Card,
  CardMedia,
  CardContent,
  Divider,
  Grid,
  IconButton,
} from "@mui/material";
import { DesktopDatePicker, TimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import axios from "axios";
// import ImageUploader from './ImageUploader';
import buildHtmlContent from "./HtmlContentBuilder";
import CategoryIcon from "@mui/icons-material/Category";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import InfoIcon from "@mui/icons-material/Info";
import ImageIcon from "@mui/icons-material/Image";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import StorageIcon from "@mui/icons-material/Storage";
import ArrowBack from "@mui/icons-material/ArrowBack";
import ArrowForward from "@mui/icons-material/ArrowForward";
import DeleteIcon from "@mui/icons-material/Delete";

const conditionOptions = {
  Nou: 1,
  Excelent: 2,
  "Foarte Buna": 3,
  Buna: 4,
  Rezonabil: 5,
};

const EditProductWoo = ({ product, wooCategories, onSave, onCancel }) => {
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const [salePrice, setSalePrice] = useState("");
  const [msrpPrice, setMsrpPrice] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("draft");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [productType, setProductType] = useState("HARD TO FIND");
  const [brand, setBrand] = useState("HERMÈS");
  const [condition, setCondition] = useState("Nou");
  const [customDescription, setCustomDescription] = useState("");
  const [isSaleScheduled, setIsSaleScheduled] = useState(false);
  const [isProductScheduled, setIsProductScheduled] = useState(false);
  const [scheduledDate, setScheduledDate] = useState(null);
  const [scheduledTime, setScheduledTime] = useState(null);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [profileImage, setProfileImage] = useState(null); // { file, id }
  const [galleryImages, setGalleryImages] = useState([]); // [{ file, id }]
  const [progress, setProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState("");
  const [existingImages, setExistingImages] = useState([]); // existing product images [{id, src}]
  const [sku, setSku] = useState("");
  const [exteriorColor, setExteriorColor] = useState("Maro");
  const [interiorColor, setInteriorColor] = useState("Bordo");
  const [exteriorMaterial, setExteriorMaterial] = useState("Monogram Canvas");
  const [interiorMaterial, setInteriorMaterial] = useState("Microfibra");
  const [includedItems, setIncludedItems] = useState([]);
  const [hardwareColor, setHardwareColor] = useState("Auriu");
  const [designerId, setDesignerId] = useState("M46197");
  const [entrupyId, setEntrupyId] = useState("DHGGCC8");
  const [location, setLocation] = useState("Exclusiv Online");
  const [length, setLength] = useState("");
  const [height, setHeight] = useState("");
  const [depth, setDepth] = useState("");
  const [detailedDescription, setDetailedDescription] = useState("");
  const [sortlyId, setSortlyId] = useState("");
  const [layawayOption, setLayawayOption] = useState("");
  const [isLayaway, setIsLayaway] = useState(false);
  const [pentru, setPentru] = useState("");

  const productTypes = [
    "BEST DEAL",
    "MUST HAVE",
    "VINTAGE",
    "HARD TO FIND",
    "LUXURA EXCLUSIVE",
    "TRENDING",
    "NEW COLLECTION",
  ];
  const brands = ["HERMÈS", "DIOR", "CHANEL", "GUCCI"];

  const consumerKey = "ck_a941824be557253d3765a1f6242e6d6a590da999";
  const consumerSecret = "cs_6b0d98e4c442e707be9888cafff1fac17cdbf259";
  const username = "ciprian.bucurei@gmail.com";
  const password = "dgUp Z1Cv Rqxg pjx2 s3TF ZjOQ";

  useEffect(() => {
    if (product) {
      setTitle(product.name);
      setPrice(product.regular_price);
      setSalePrice(product.sale_price);
      // Try to read MSRP from meta_data if not on root
      const msrpFromMeta = Array.isArray(product.meta_data)
        ? product.meta_data.find((m) => m.key === "msrp_price")?.value
        : undefined;
      setMsrpPrice(product.msrp_price || msrpFromMeta || "");
      setDescription(product.description);
      setStatus(product.status);
      setExistingImages(Array.isArray(product.images) ? product.images : []);
      // Map categories from product to the hierarchical options used by the Autocomplete
      // We'll align selectedCategories to be array of category objects { id, name, children? }
      // by matching ids in the flattened categories list once it's computed.
      setProductType(
        product.attributes.find((attr) => attr.name === "Badge")?.options[0] ||
          "HARD TO FIND"
      );
      setBrand(
        product.attributes.find((attr) => attr.name === "Designeri")
          ?.options[0] || "HERMÈS"
      );
      setCondition(
        product.attributes.find((attr) => attr.name === "Condiție")
          ?.options[0] || "Nou"
      );
      setCustomDescription(
        product.attributes.find((attr) => attr.name === "Descriere Condiție")
          ?.options[0] || ""
      );
      setExteriorColor(
        product.attributes.find((attr) => attr.name === "Culoare")
          ?.options[0] || "Maro"
      );
      setInteriorColor(
        product.attributes.find((attr) => attr.name === "Culoare Interioară")
          ?.options[0] || "Bordo"
      );
      setExteriorMaterial(
        product.attributes.find((attr) => attr.name === "Material Exterior")
          ?.options[0] || "Monogram Canvas"
      );
      setInteriorMaterial(
        product.attributes.find((attr) => attr.name === "Material Interior")
          ?.options[0] || "Microfibra"
      );
      setIncludedItems(
        product.attributes.find((attr) => attr.name === "Insotit")?.options ||
          []
      );
      setHardwareColor(
        product.attributes.find((attr) => attr.name === "Culoare Hardware")
          ?.options[0] || "Auriu"
      );
      setDesignerId(
        product.attributes.find((attr) => attr.name === "DesignerID")
          ?.options[0] || "M46197"
      );
      setEntrupyId(
        product.attributes.find((attr) => attr.name === "Entrupy")
          ?.options[0] || "DHGGCC8"
      );
      setLocation(
        product.attributes.find((attr) => attr.name === "Locație")
          ?.options[0] || "Exclusiv Online"
      );
      setLength(
        product.attributes.find((attr) => attr.name === "Lungimea")
          ?.options[0] || ""
      );
      setHeight(
        product.attributes.find((attr) => attr.name === "Inălțime")
          ?.options[0] || ""
      );
      setDepth(
        product.attributes.find((attr) => attr.name === "Adâncime")
          ?.options[0] || ""
      );
      setDetailedDescription(
        product.attributes.find((attr) => attr.name === "Descriere Detaliată")
          ?.options[0] || ""
      );
      setSortlyId(
        product.attributes.find((attr) => attr.name === "SortlyID")
          ?.options[0] || ""
      );
      // Prepopulate LLP (SUMO Payment Plans) from meta_data if present
      const meta = Array.isArray(product.meta_data) ? product.meta_data : [];
      const sumoEnabled =
        meta.find((m) => m.key === "_sumo_pp_enable_sumopaymentplans")
          ?.value === "yes";
      const selectedPlans = meta.find(
        (m) => m.key === "_sumo_pp_selected_plans"
      )?.value;
      // Map plan IDs back to labels
      const plansToLabel = (plans) => {
        const ids = Array.isArray(plans?.col_1) ? plans.col_1 : [];
        const setIds = new Set(ids.map(String));
        if (setIds.has("106724")) return "1 Rata Speciala";
        if (setIds.has("10956") && setIds.has("10957") && setIds.has("10969"))
          return "3 Rate";
        if (setIds.has("10956") && setIds.has("10957")) return "2 Rate";
        if (setIds.has("10956")) return "1 Rata";
        return "";
      };
      setLayawayOption(plansToLabel(selectedPlans));
      setIsLayaway(!!sumoEnabled);
      setPentru(
        product.attributes.find((attr) => attr.name === "Pentru")?.options[0] ||
          ""
      );
      setSku(product.sku);
    }
  }, [product]);

  // Once wooCategories are available, compute the flattened list and then map initial selection
  const renderCategoryOptions = (categories, level = 0) => {
    return categories.flatMap((category) => [
      {
        ...category,
        label: `${"—".repeat(level)} ${category.name}`,
      },
      ...renderCategoryOptions(category.children || [], level + 1),
    ]);
  };

  const flatCategories = renderCategoryOptions(wooCategories || []);

  useEffect(() => {
    if (product && Array.isArray(product.categories) && flatCategories.length) {
      const ids = new Set(product.categories.map((c) => c.id));
      const preselected = flatCategories.filter((c) => ids.has(c.id));
      setSelectedCategories(preselected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, flatCategories.length]);

  const compressAndResizeImage = async (imageFile) => {
    try {
      const formData = new FormData();
      formData.append("image", imageFile);
      const response = await axios.post(
        "https://server-9p4hx.kinsta.app/api/masterdata/compress",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          responseType: "blob",
        }
      );
      return new File([response.data], imageFile.name, {
        type: imageFile.type,
      });
    } catch (error) {
      console.error("Error compressing and resizing image:", error);
      alert("Failed to compress and resize image.");
      return null;
    }
  };

  const uploadImage = async (imageFile) => {
    const url = "https://www.luxuraelite.ro/wp-json/wp/v2/media";

    const formData = new FormData();
    formData.append("file", imageFile);

    const auth = btoa(`${username}:${password}`);

    try {
      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Basic ${auth}`,
          "Content-Disposition": `attachment; filename=${imageFile.name}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          setProgress(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          );
        },
      });

      console.log("Image uploaded successfully:", response.data);
      return response.data.id;
    } catch (error) {
      console.error(
        "Error uploading image:",
        error.response ? error.response.data : error.message
      );
      alert("Failed to upload image.");
      return null;
    }
  };

  // Fallback: fetch product images from backend if missing on prop
  useEffect(() => {
    const fetchImages = async () => {
      if (product && (!product.images || !product.images.length)) {
        try {
          const { data } = await axios.get(
            `https://server-9p4hx.kinsta.app/api/masterdata/woo/product/${product.id}`
          );
          if (Array.isArray(data.images)) setExistingImages(data.images);
        } catch (e) {
          console.error("Failed to fetch product for images:", e);
        }
      }
    };
    fetchImages();
  }, [product]);

  const handleImageChange = async (type, images) => {
    if (type === "profile") {
      const imageFile = images;
      if (!imageFile) {
        setProfileImage(null);
        return;
      }
      const compressed = await compressAndResizeImage(imageFile);
      if (compressed) {
        const imageId = await uploadImage(compressed);
        if (imageId) {
          setProfileImage({ file: imageFile, id: imageId });
        }
      }
    } else {
      const newGalleryImages = [];
      let index = galleryImages.length + 1;
      for (const imageFile of images) {
        setUploadStatus(`Uploading image ${index} of ${images.length}`);
        const compressed = await compressAndResizeImage(imageFile);
        if (compressed) {
          const imageId = await uploadImage(compressed);
          if (imageId) {
            newGalleryImages.push({ file: imageFile, id: imageId });
          }
          index++;
        }
      }
      setGalleryImages((prev) => [...prev, ...newGalleryImages]);
      setUploadStatus("Done");
    }
  };

  const handleMoveImageLeft = (index) => {
    if (index > 0) {
      const newGalleryImages = [...galleryImages];
      const temp = newGalleryImages[index - 1];
      newGalleryImages[index - 1] = newGalleryImages[index];
      newGalleryImages[index] = temp;
      setGalleryImages(newGalleryImages);
    }
  };

  const handleMoveImageRight = (index) => {
    if (index < galleryImages.length - 1) {
      const newGalleryImages = [...galleryImages];
      const temp = newGalleryImages[index + 1];
      newGalleryImages[index + 1] = newGalleryImages[index];
      newGalleryImages[index] = temp;
      setGalleryImages(newGalleryImages);
    }
  };

  const handleDeleteGalleryImage = (index) => {
    const updatedImages = galleryImages.filter((_, i) => i !== index);
    setGalleryImages(updatedImages);
  };

  const handleRemoveExistingImage = (index) => {
    setExistingImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSaveProduct = async () => {
    const profileImageId = profileImage?.id || null;
    const galleryImageIds = galleryImages.map((img) => img.id).filter(Boolean);

    const htmlTitle = `
        <span style="font-size: 10px; color: rgb(101, 101, 101);letter-spacing: .15em;">${productType}</span><br>
        <strong>${brand}</strong><br>
        <div style="margin-top:10px; font-size:16px;">${title}</div><br>
        `;

    const finalDescription = buildHtmlContent({
      conditionValue: Number(conditionOptions[condition] || 0),
      customDescription,
      exteriorColor,
      interiorColor,
      exteriorMaterial,
      interiorMaterial,
      includedItems,
      hardwareColor,
      designerId,
      entrupyId,
      location,
      length,
      height,
      depth,
      detailedDescription,
      sortlyId,
      salePrice,
      price,
      brand,
      layawayPlan: isLayaway ? layawayOption : null,
    });

    const publishDateTime =
      isProductScheduled && scheduledDate && scheduledTime
        ? dayjs(scheduledDate)
            .hour(dayjs(scheduledTime).hour())
            .minute(dayjs(scheduledTime).minute())
            .second(0)
            .format("YYYY-MM-DDTHH:mm:ss")
        : null;

    // Build images payload preserving existing ones (unless removed), and new uploads
    const keptExistingIds = existingImages.map((img) => img.id).filter(Boolean);
    let imagesPayload = [];
    if (profileImageId) {
      imagesPayload.push({ id: profileImageId });
    } else if (keptExistingIds.length) {
      imagesPayload.push({ id: keptExistingIds[0] });
    }
    const remainingExisting = keptExistingIds
      .slice(profileImageId ? 0 : 1)
      .map((id) => ({ id }));
    imagesPayload = [
      ...imagesPayload,
      ...remainingExisting,
      ...galleryImageIds.map((id) => ({ id })),
    ];

    const productData = {
      name: htmlTitle,
      regular_price: price,
      sale_price: salePrice,
      msrp_price: msrpPrice,
      description: finalDescription,
      status: isProductScheduled ? "future" : status,
      date_created: publishDateTime,
      categories: selectedCategories.map((category) => ({ id: category.id })),
      date_on_sale_from:
        isSaleScheduled && dateFrom
          ? dayjs(dateFrom).format("YYYY-MM-DD")
          : null,
      date_on_sale_to:
        isSaleScheduled && dateTo ? dayjs(dateTo).format("YYYY-MM-DD") : null,
      images: imagesPayload.length ? imagesPayload : product.images || [],
      stock_quantity: 1,
      manage_stock: true,
      sku: sku,
      tags: [{ name: brand }],
      attributes: [
        { id: 9, name: "Condiție", options: [condition] },
        { id: 10, name: "Designeri", options: [brand] },
        { id: 15, name: "Badge", options: [productType] },
        { id: 2, name: "Culoare", options: [exteriorColor] },
        {
          id: 11,
          name: "Categorie",
          options: selectedCategories.map((category) => category.name),
        },
        { id: 24, name: "DesignerID", options: [designerId] },
        { id: 22, name: "Entrupy", options: [entrupyId] },
        { id: 23, name: "Insotit", options: includedItems },
        { id: 17, name: "Pentru", options: [pentru] },
      ],
      meta_data: [{ key: "msrp_price", value: msrpPrice }],
    };

    try {
      const productResponse = await axios.put(
        `https://www.luxuraelite.ro/wp-json/wc/v3/products/${product.id}`,
        productData,
        {
          headers: {
            Authorization: "Basic " + btoa(`${consumerKey}:${consumerSecret}`),
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Product Response:", productResponse.data);
      if (isLayaway) {
        const numericPrice = Number(salePrice || price) || 0;
        const resolvedPlan =
          layawayOption ||
          (numericPrice > 0 && numericPrice <= 2000
            ? "1 Rata Speciala"
            : "");
        if (resolvedPlan) {
          await setSumoPaymentPlans(product.id, resolvedPlan);
        }
      }
      onSave(productResponse.data);
    } catch (error) {
      console.error(
        "Error updating product:",
        error.response ? error.response.data : error.message
      );
      alert("Failed to update product.");
    }
  };

  const setSumoPaymentPlans = async (productId, layawayOption) => {
    const sumoMetaData = [
      { key: "_sumo_pp_enable_sumopaymentplans", value: "yes" },
      { key: "_sumo_pp_payment_type", value: "payment-plans" },
      { key: "_sumo_pp_available_dates_from", value: "" },
      { key: "_sumo_pp_available_dates_to", value: "" },
      { key: "_sumo_pp_apply_global_settings", value: "" },
      { key: "_sumo_pp_force_deposit", value: "" },
      {
        key: "_sumo_pp_default_selected_type",
        value: "payment-plans",
      },
      { key: "_sumo_pp_deposit_type", value: "pre-defined" },
      { key: "_sumo_pp_deposit_price_type", value: "fixed-price" },
      { key: "_sumo_pp_pay_balance_type", value: "after" },
      { key: "_sumo_pp_pay_balance_after", value: "" },
      { key: "_sumo_pp_pay_balance_before", value: "" },
      { key: "_sumo_pp_pay_balance_before_booked_date", value: "" },
      { key: "_sumo_pp_set_expired_deposit_payment_as", value: "normal" },
      { key: "_sumo_pp_fixed_deposit_price", value: "" },
      { key: "_sumo_pp_fixed_deposit_percent", value: "" },
      {
        key: "_sumo_pp_user_defined_deposit_type",
        value: "percent-of-product-price",
      },
      { key: "_sumo_pp_min_user_defined_deposit_price", value: "" },
      { key: "_sumo_pp_max_user_defined_deposit_price", value: "" },
      { key: "_sumo_pp_min_deposit", value: "" },
      { key: "_sumo_pp_max_deposit", value: "" },
    ];

    let plans = [];
    switch (layawayOption) {
      case "1 Rata":
        plans = ["10956"];
        break;
      case "2 Rate":
        plans = ["10956", "10957"];
        break;
      case "3 Rate":
        plans = ["10956", "10957", "10969"];
        break;
      case "1 Rata Speciala":
        plans = ["106724"];
        break;
      default:
        break;
    }

    sumoMetaData.push({
      key: "_sumo_pp_selected_plans",
      value: { col_1: plans },
    });

    try {
      await axios.put(
        `https://www.luxuraelite.ro/wp-json/wc/v3/products/${productId}`,
        { meta_data: sumoMetaData },
        {
          headers: {
            Authorization: "Basic " + btoa(`${consumerKey}:${consumerSecret}`),
            "Content-Type": "application/json",
          },
        }
      );
      console.log("SUMO Payment Plans set successfully");
    } catch (error) {
      console.error(
        "Error setting SUMO Payment Plans:",
        error.response ? error.response.data : error.message
      );
      alert("Failed to set SUMO Payment Plans.");
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ p: 2 }}>
        <Typography variant="h4" gutterBottom>
          Edit Product
        </Typography>
        <Card sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            <CategoryIcon sx={{ mr: 1, verticalAlign: "middle" }} /> Informații
            produs
          </Typography>
          <Grid container spacing={2}>
            {sku && (
              <Grid item xs={12} sm={6}>
                <TextField
                  label="SKU"
                  value={sku}
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Badge</InputLabel>
                <Select
                  value={productType}
                  onChange={(e) => setProductType(e.target.value)}
                  label="Badge"
                >
                  {productTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Brand</InputLabel>
                <Select
                  value={brand}
                  onChange={(e) => setBrand(e.target.value)}
                  label="Brand"
                >
                  {brands.map((brand) => (
                    <MenuItem key={brand} value={brand}>
                      {brand}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Model"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Autocomplete
                  multiple
                  options={flatCategories}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  value={selectedCategories}
                  onChange={(event, newValue) =>
                    setSelectedCategories(newValue)
                  }
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={option.id}
                        label={option.name}
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Categorii"
                      placeholder="Selectează categoriile"
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Card>

        <Divider>
          <MonetizationOnIcon /> Pricing
        </Divider>
        <Box sx={{ display: "flex", alignItems: "center", mt: 2, mb: 2 }}>
          <TextField
            label="Preț"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            fullWidth
            sx={{ mr: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">RON</InputAdornment>
              ),
            }}
          />
          <TextField
            label="Preț la Reducere"
            value={salePrice}
            onChange={(e) => setSalePrice(e.target.value)}
            fullWidth
            sx={{ mr: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">RON</InputAdornment>
              ),
            }}
          />
          <TextField
            label="Preț de Retail MSRP"
            value={msrpPrice}
            onChange={(e) => setMsrpPrice(e.target.value)}
            fullWidth
            sx={{ mr: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">RON</InputAdornment>
              ),
            }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isSaleScheduled}
                onChange={(e) => setIsSaleScheduled(e.target.checked)}
              />
            }
            label="Schedule Sale"
          />
        </Box>
        {isSaleScheduled && (
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <DesktopDatePicker
              label="De la"
              inputFormat="DD/MM/YYYY"
              value={dateFrom}
              onChange={(newValue) => setDateFrom(newValue)}
              renderInput={(params) => <TextField {...params} sx={{ mr: 2 }} />}
            />
            <DesktopDatePicker
              label="Până la"
              inputFormat="DD/MM/YYYY"
              value={dateTo}
              onChange={(newValue) => setDateTo(newValue)}
              renderInput={(params) => <TextField {...params} />}
            />
          </Box>
        )}
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <FormControl sx={{ mr: 2, flex: "0 0 200px" }}>
            <InputLabel>Condiție</InputLabel>
            <Select
              value={condition}
              onChange={(e) => setCondition(e.target.value)}
              label="Condiție"
            >
              {Object.keys(conditionOptions).map((cond) => (
                <MenuItem key={cond} value={cond}>
                  {cond}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Descriere Condiție"
            value={customDescription}
            onChange={(e) => setCustomDescription(e.target.value)}
            fullWidth
            sx={{ flex: 1 }}
          />
        </Box>
        <TextField
          label="Descriere"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          fullWidth
          multiline
          rows={4}
          sx={{ mb: 2 }}
        />
        <Divider>
          <InfoIcon /> Condition & Description
        </Divider>
        <Box sx={{ display: "flex", alignItems: "center", mt: 2, mb: 2 }}>
          <FormControl sx={{ mr: 2, flex: 1 }}>
            <InputLabel>Condiție</InputLabel>
            <Select
              value={condition}
              onChange={(e) => setCondition(e.target.value)}
              label="Condiție"
            >
              {Object.keys(conditionOptions).map((cond) => (
                <MenuItem key={cond} value={cond}>
                  {cond}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <TextField
          label="Descriere Condiție"
          value={customDescription}
          onChange={(e) => setCustomDescription(e.target.value)}
          fullWidth
          multiline
          rows={4}
          sx={{ mb: 2 }}
        />

        <Divider>
          <ImageIcon /> Images
        </Divider>
        <Box sx={{ display: "flex", mt: 2, mb: 2 }}>
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mr: 2,
            }}
          >
            <Box
              sx={{
                width: "100%",
                paddingTop: "177.78%",
                backgroundColor: "#f0f0f0",
                backgroundImage: profileImage
                  ? `url(${URL.createObjectURL(profileImage.file)})`
                  : "none",
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
                border: "1px solid #ddd",
                mb: 2,
              }}
            />
            <Button variant="contained" component="label">
              Upload Profile Image
              <input
                type="file"
                hidden
                onChange={(e) =>
                  handleImageChange("profile", e.target.files[0])
                }
              />
            </Button>
            {profileImage && (
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setProfileImage(null)}
                sx={{ mt: 1 }}
              >
                Delete
              </Button>
            )}
          </Box>
          <Box sx={{ flex: 2, display: "flex", flexDirection: "column" }}>
            <Button variant="contained" component="label" sx={{ mb: 2 }}>
              Upload Gallery Images
              <input
                type="file"
                multiple
                hidden
                onChange={(e) =>
                  handleImageChange("gallery", Array.from(e.target.files))
                }
              />
            </Button>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {galleryImages.map((image, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: 136,
                      height: 180,
                      backgroundColor: "#f0f0f0",
                      backgroundImage: `url(${URL.createObjectURL(image.file)})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      position: "relative",
                      border: "1px solid #ddd",
                    }}
                  />
                  <Box
                    sx={{ display: "flex", justifyContent: "center", mt: 1 }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleMoveImageLeft(index)}
                    >
                      <ArrowBack />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleMoveImageRight(index)}
                    >
                      <ArrowForward />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleDeleteGalleryImage(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
        {existingImages.length > 0 && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Imagini existente
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
              {existingImages.map((img, index) => (
                <Card key={img.id || index} sx={{ width: 140 }}>
                  <CardMedia
                    component="img"
                    height="100"
                    image={img.src}
                    alt={`Existing ${index + 1}`}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      p: 1,
                    }}
                  >
                    <Typography variant="caption">#{index + 1}</Typography>
                    <Button
                      size="small"
                      color="error"
                      onClick={() => handleRemoveExistingImage(index)}
                    >
                      Remove
                    </Button>
                  </Box>
                </Card>
              ))}
            </Box>
          </Box>
        )}
        {uploadStatus && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Typography variant="body2" color="textSecondary">
              {uploadStatus}
            </Typography>
          </Box>
        )}
        {progress > 0 && (
          <Box sx={{ width: "100%", mb: 2 }}>
            <Typography
              variant="body2"
              color="textSecondary"
            >{`Uploading images: ${progress}%`}</Typography>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
        )}

        <Divider>
          <LocalOfferIcon /> Attributes
        </Divider>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <FormControl sx={{ mr: 2, flex: "0 0 200px" }}>
            <InputLabel>Culoare Exterioară</InputLabel>
            <Select
              value={exteriorColor}
              onChange={(e) => setExteriorColor(e.target.value)}
              label="Culoarea Exterioară"
            >
              <MenuItem value="Maro">Maro</MenuItem>
              <MenuItem value="Negru">Negru</MenuItem>
              <MenuItem value="Alb">Alb</MenuItem>
              <MenuItem value="Albastru">Albastru</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ mr: 2, flex: "0 0 200px" }}>
            <InputLabel>Culoare Interioară</InputLabel>
            <Select
              value={interiorColor}
              onChange={(e) => setInteriorColor(e.target.value)}
              label="Culoarea Interioară"
            >
              <MenuItem value="Bordo">Bordo</MenuItem>
              <MenuItem value="Negru">Negru</MenuItem>
              <MenuItem value="Alb">Alb</MenuItem>
              <MenuItem value="Albastru">Albastru</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <FormControl sx={{ mr: 2, flex: "0 0 200px" }}>
            <InputLabel>Material Exterior</InputLabel>
            <Select
              value={exteriorMaterial}
              onChange={(e) => setExteriorMaterial(e.target.value)}
              label="Material Exterior"
            >
              <MenuItem value="Monogram Canvas">Monogram Canvas</MenuItem>
              <MenuItem value="Piele">Piele</MenuItem>
              <MenuItem value="Bumbac">Bumbac</MenuItem>
              <MenuItem value="Aur">Aur</MenuItem>
              <MenuItem value="Argint">Argint</MenuItem>
              <MenuItem value="Oțel">Oțel</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ mr: 2, flex: "0 0 200px" }}>
            <InputLabel>Material Interior</InputLabel>
            <Select
              value={interiorMaterial}
              onChange={(e) => setInteriorMaterial(e.target.value)}
              label="Material Interior"
            >
              <MenuItem value="Microfibra">Microfibra</MenuItem>
              <MenuItem value="Piele">Piele</MenuItem>
              <MenuItem value="Material">Material</MenuItem>
              <MenuItem value="Microfibra">Microfibra</MenuItem>
              <MenuItem value="Bumbac">Bumbac</MenuItem>
              <MenuItem value="Canvas">Canvas</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <FormControl sx={{ mr: 2, flex: "0 0 300px" }}>
            <InputLabel>Vine Însoțit</InputLabel>
            <Select
              multiple
              value={includedItems}
              onChange={(e) => setIncludedItems(e.target.value)}
              renderValue={(selected) => selected.join(", ")}
              label="Vine Însoțit"
            >
              <MenuItem value="Dust bag">Dust bag</MenuItem>
              <MenuItem value="Cutie">Cutie</MenuItem>
              <MenuItem value="Certificat de conformitate">
                Certificat de conformitate
              </MenuItem>
              <MenuItem value="Certificat Entrupy">Certificat Entrupy</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ mr: 2, flex: "0 0 200px" }}>
            <InputLabel>Culoare Hardware</InputLabel>
            <Select
              value={hardwareColor}
              onChange={(e) => setHardwareColor(e.target.value)}
              label="Culoare Hardware"
            >
              <MenuItem value="Auriu">Auriu</MenuItem>
              <MenuItem value="Argintiu">Argintiu</MenuItem>
              <MenuItem value="Mat">Mat</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <TextField
            label="Designer ID"
            value={designerId}
            onChange={(e) => setDesignerId(e.target.value)}
            fullWidth
            sx={{ mr: 2 }}
          />
          <TextField
            label="Entrupy ID"
            value={entrupyId}
            onChange={(e) => setEntrupyId(e.target.value)}
            fullWidth
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <FormControl sx={{ mr: 2, flex: "0 0 200px" }}>
            <InputLabel>Locație</InputLabel>
            <Select
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              label="Locație"
            >
              <MenuItem value="Exclusiv Online">Exclusiv Online</MenuItem>
              <MenuItem value="Luxura Boutique Timișoara">
                Luxura Boutique Timișoara
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <TextField
            label="Lungimea (cm)"
            value={length}
            onChange={(e) => setLength(e.target.value)}
            fullWidth
            sx={{ mr: 2 }}
          />
          <TextField
            label="Inălțime (cm)"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
            fullWidth
            sx={{ mr: 2 }}
          />
          <TextField
            label="Adâncime (cm)"
            value={depth}
            onChange={(e) => setDepth(e.target.value)}
            fullWidth
          />
        </Box>
        <TextField
          label="Sortly ID"
          value={sortlyId}
          onChange={(e) => setSortlyId(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
        />
        <TextField
          label="Descriere Detaliată"
          value={detailedDescription}
          onChange={(e) => setDetailedDescription(e.target.value)}
          fullWidth
          multiline
          rows={4}
          sx={{ mb: 2 }}
        />
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <FormControl sx={{ mr: 2, flex: "0 0 200px" }}>
            <InputLabel>Pentru</InputLabel>
            <Select
              value={pentru}
              onChange={(e) => setPentru(e.target.value)}
              label="Pentru"
            >
              <MenuItem value="Femei">Femei</MenuItem>
              <MenuItem value="Barbati">Barbati</MenuItem>
              <MenuItem value="Copii">Copii</MenuItem>
              <MenuItem value="Casa">Casa</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={status === "publish"}
                onChange={(e) =>
                  setStatus(e.target.checked ? "publish" : "draft")
                }
              />
            }
            label={status === "publish" ? "Published" : "Ciorna"}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isProductScheduled}
                onChange={(e) => setIsProductScheduled(e.target.checked)}
              />
            }
            label="Programare"
          />
        </Box>
        {isProductScheduled && (
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <DesktopDatePicker
              label="Data"
              inputFormat="DD/MM/YYYY"
              value={scheduledDate}
              onChange={(newValue) => setScheduledDate(newValue)}
              renderInput={(params) => <TextField {...params} sx={{ mr: 2 }} />}
            />
            <TimePicker
              label="Ora"
              value={scheduledTime}
              onChange={(newValue) => setScheduledTime(newValue)}
              renderInput={(params) => <TextField {...params} />}
            />
          </Box>
        )}
        <Divider>
          <InfoIcon /> Publicare
        </Divider>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={status === "publish"}
                onChange={(e) =>
                  setStatus(e.target.checked ? "publish" : "draft")
                }
              />
            }
            label={status === "publish" ? "Published" : "Ciorna"}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isProductScheduled}
                onChange={(e) => setIsProductScheduled(e.target.checked)}
              />
            }
            label="Programare"
          />
          <FormControl sx={{ ml: 2, flex: "0 0 200px" }}>
            <InputLabel>Locație</InputLabel>
            <Select
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              label="Locație"
            >
              <MenuItem value="Exclusiv Online">Exclusiv Online</MenuItem>
              <MenuItem value="Luxura Boutique Timișoara">
                Luxura Boutique Timișoara
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
        {isProductScheduled && (
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <DesktopDatePicker
              label="Data"
              inputFormat="DD/MM/YYYY"
              value={scheduledDate}
              onChange={(newValue) => setScheduledDate(newValue)}
              renderInput={(params) => <TextField {...params} sx={{ mr: 2 }} />}
            />
            <TimePicker
              label="Ora"
              value={scheduledTime}
              onChange={(newValue) => setScheduledTime(newValue)}
              renderInput={(params) => <TextField {...params} />}
            />
          </Box>
        )}

        <Divider>
          <StorageIcon /> Layaway
        </Divider>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={isLayaway}
                onChange={(e) => setIsLayaway(e.target.checked)}
              />
            }
            label="Dorești produsul în LLP?"
          />
        </Box>
        {isLayaway && (
          <>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>LLP</InputLabel>
              <Select
                value={layawayOption}
                onChange={(e) => setLayawayOption(e.target.value)}
                label="LLP"
              >
                {(() => {
                  const specialItem = (
                    <MenuItem key="1 Rata Speciala" value="1 Rata Speciala">
                      1 Rata Speciala (50% avans)
                    </MenuItem>
                  );
                  const standardItems = [
                    <MenuItem key="1 Rata" value="1 Rata">
                      1 Rata
                    </MenuItem>,
                    <MenuItem key="2 Rate" value="2 Rate">
                      2 Rate
                    </MenuItem>,
                    <MenuItem key="3 Rate" value="3 Rate">
                      3 Rate
                    </MenuItem>,
                  ];
                  const numericPrice = Number(salePrice || price) || 0;
                  if (numericPrice > 0 && numericPrice <= 2000) {
                    return [specialItem, ...standardItems];
                  }
                  return [...standardItems, specialItem];
                })()}
              </Select>
            </FormControl>
          </>
        )}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveProduct}
          >
            Salvează Produs
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={onCancel}
            sx={{ ml: 2 }}
          >
            Anulează
          </Button>
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default EditProductWoo;
